module.exports = __webpack_public_path__ + "img/down-phone.c63327ca.png";